import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

const intlPrefix = 'sizesModal';

export const defined = defineMessages({
  breitlingStrapSize: {
    id: `plp.strapSize.heading`,
    defaultMessage: 'Breitling strap size',
  },
  howToMeasure: {
    id: `plp.strapSize.howToMeasure`,
    defaultMessage: 'How to measure your wrist?',
  },
  needARuler: {
    id: `plp.strapSize.needARuler`,
    defaultMessage: 'Need a ruler for measurements?',
  },
  printTheRuler: {
    id: 'plp.strapSize.printTheRuler',
    defaultMessage: 'Print the ruler',
  },
  strapSize: {
    id: `plp.strapSize.form.strapSize`,
    defaultMessage: 'strap size',
  },
  rubberSize: {
    id: `plp.strapSize.form.rubberSize`,
    defaultMessage: 'rubber size',
  },
  leatherSize: {
    id: `plp.strapSize.form.leatherSize`,
    defaultMessage: 'leather size',
  },
  small: {
    id: `plp.strapSize.form.small`,
    defaultMessage: 'small',
  },
  smallRubberSize: {
    id: `plp.strapSize.form.smallRubberSize`,
    defaultMessage: '135mm to 165mm',
  },
  smallRubberSizeInch: {
    id: `plp.strapSize.form.smallRubberSizeInch`,
    defaultMessage: '5.31 to 6.50 inch',
  },
  smallLeatherSize: {
    id: `plp.strapSize.form.smallLeatherSize`,
    defaultMessage: '135mm to 165mm',
  },
  smallLeatherSizeInch: {
    id: `plp.strapSize.form.smallLeatherSizeInch`,
    defaultMessage: '5.31 to 6.50 inch',
  },
  standard: {
    id: `plp.strapSize.form.standard`,
    defaultMessage: 'standard',
  },
  standardRubberSize: {
    id: `plp.strapSize.form.standardRubberSize`,
    defaultMessage: '170mm to 220mm',
  },
  standardRubberSizeInch: {
    id: `plp.strapSize.form.standardRubberSizeInch`,
    defaultMessage: '6.69 to 8.66 inch',
  },
  standardLeatherSize: {
    id: `plp.strapSize.form.standardLeatherSize`,
    defaultMessage: '165mm to 185mm',
  },
  standardLeatherSizeInch: {
    id: `plp.strapSize.form.standardLeatherSizeInch`,
    defaultMessage: '6.50 to 7.28 inch',
  },
  large: {
    id: `plp.strapSize.form.large`,
    defaultMessage: 'large',
  },
  largeLeatherSize: {
    id: `plp.strapSize.form.largeLeatherSize`,
    defaultMessage: '185mm to 215mm',
  },
  largeLeatherSizeInch: {
    id: `plp.strapSize.form.largeLeatherSizeInch`,
    defaultMessage: '7.28 to 8.46 inch',
  },
});

export const MeasuringTool = (
  <FormattedMessage
    defaultMessage='measuring tool'
    id='plp.strapSize.measuringTool'
  />
);
export const TopDescription = (downloadedSizePdfHref: string) => (
  <FormattedMessage
    defaultMessage='To find the best fit of a strap or bracelet, please use our wrist {measuringTool}. Most of our straps come in Short, Standard and Long lengths, with ranges varying slightly based on case size and thickness of the compatible watch.'
    id='plp.strapSize.topDescription'
    values={{
      measuringTool: (
        <LinkWithLocale
          href={downloadedSizePdfHref}
          rel='noopener noreferrer'
          target='_blank'
        >
          {MeasuringTool}
        </LinkWithLocale>
      ),
    }}
  />
);

export const MiddleDescription = (
  <FormattedMessage
    defaultMessage='We offer complimentary sizing of metal bracelets when a watch is purchased online or through our contact center. For rubber straps, we recommend a visit to one of our boutiques or authorized dealers to properly size the band.'
    id='plp.strapSize.middleDescription'
  />
);

export const PrintTheRuler = (
  <FormattedMessage
    defaultMessage='Print the ruler'
    id={`${intlPrefix}.printTheRuler`}
  />
);

export const BottomDescription = (
  <FormattedMessage
    defaultMessage='Please be aware of the instruction in the paper for the correct measurement and of the possibility of possible small discrepancy in measures.'
    id='plp.strapSize.bottomDescription'
  />
);
